/* NEX ice: Winter freeze on desktop (capsule + dropdown), logo twinkle */
(function () {
  'use strict';
  var hdr = document.querySelector('[data-header]');
  if (!hdr) return;

  var logo = hdr.querySelector('.hdr__logo');
  if (logo) {
    [['22%', '18%'], ['74%', '56%']].forEach(function (xy) {
      var s = document.createElement('i'); s.className = 'lg'; s.setAttribute('aria-hidden', 'true');
      s.style.left = xy[0]; s.style.top = xy[1]; logo.appendChild(s);
    });
  }

  var ICO = '<svg class="winter__ico" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7"/></svg>';
  function wrap(a, ico, b) {
    var t = (a.textContent || '').trim();
    if (!t || a.querySelector('.fz')) return;
    a.setAttribute('aria-label', t); a.textContent = '';
    if (b != null) a.style.setProperty('--b', b);
    if (ico) a.insertAdjacentHTML('beforeend', ICO);
    t.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.className = 'fz'; s.setAttribute('aria-hidden', 'true'); s.style.setProperty('--n', i);
      s.innerHTML = '<span class="fz__b"></span><span class="fz__i"></span><span class="fz__f"></span>';
      s.firstChild.textContent = ch; s.children[1].setAttribute('data-c', ch); s.children[2].setAttribute('data-c', ch);
      a.appendChild(s);
    });
  }
  var lis = [].slice.call(hdr.querySelectorAll('.hdr__links > li'));
  lis.forEach(function (li) {
    var a = li.firstElementChild;
    if (!a || li.classList.contains('hdr__more') || (a.textContent || '').trim().toLowerCase() !== 'winter') return;
    li.classList.add('is-winter');
    wrap(a, true);
    a.insertAdjacentHTML('beforeend', '<i class="glint" aria-hidden="true" style="--x:24%;--y:34%;--k:0"></i><i class="glint" aria-hidden="true" style="--x:72%;--y:62%;--k:1"></i>');
    var k = li.getAttribute('data-dd'), panel = k !== null ? hdr.querySelector('[data-dd-panel="' + k + '"]') : null;
    if (panel) {
      panel.classList.add('is-winter');
      [].forEach.call(panel.querySelectorAll('.hdr__ddbox a'), function (x, i) { wrap(x, false, i); });
    }
    var go = function () { setTimeout(function () { li.classList.add('is-frozen'); }, 300); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  });
})();
